export const TYPE_GROUP = 1
export const TYPE_QUESTION = 2
export const QUESTION_TYPES = {
    gallery_image: 2,
    image: 3,
    open_answer: 4,
    number_answer: 5,
    closed_answer: 6,
    pdf_answer: 7,
    video_answer: 8,
    select_answer: 9,
    image_text: 10,
    images_text: 11,
    images_text2: 12,
    multiple_select: 13,
    drawing_image: 14,
    option_text: 16,
}
export const EMAIL_SOURCE_TYPES = [QUESTION_TYPES.open_answer, QUESTION_TYPES.select_answer, QUESTION_TYPES.multiple_select]